import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  container: {
    maxWidth: 800,
    alignSelf: 'center',
    width: '100%',
    paddingVertical: 40,
  },
  formWrapper: {
    backgroundColor: 'white',
    borderRadius: 8,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 5,
  },
  formHeader: {
    padding: 40,
    paddingBottom: 25,
    borderBottomWidth: 1,
    borderBottomColor: '#eee',
  },
  formContent: {
    padding: 40,
    paddingTop: 25,
    paddingBottom: 30,
  },
  formTitle: {
    fontSize: 28,
    fontWeight: 'bold',
  },
  dateRow: {
    gap: 20,
  },
  actions: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    gap: 16,
    marginTop: 30,
  },
  button: {
    paddingVertical: 12,
    paddingHorizontal: 32,
    minWidth: 120,
    justifyContent: 'center',
  },
});